export const validSSN = (value: string) => {
    return value.match(/^\d{3}-\d{2}-\d{4}$/) !== null;
};
